/* Synful storefront — theme behaviour (no dependencies). */
(function () {
  'use strict';

  var T = window.sfTheme || {};
  var R = T.routes || {};
  var S = T.strings || {};

  /* ---------------------------------------------------------------- utils */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function store(key, val) {
    try {
      if (val === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    function fmt(n, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        default: return fmt(cents, 2);
      }
    });
  }

  var toastTimer;
  function toast(msg) {
    var el = qs('[data-sf-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 400);
    }, 2600);
  }

  /* ------------------------------------------------- drawers & overlays */
  var Drawer = (function () {
    var current = null, lastTrigger = null, closeTimer = null;
    var overlay = qs('[data-sf-overlay]');
    var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

    function setTriggers(id, expanded) {
      qsa('[aria-controls="' + id + '"]').forEach(function (b) { if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', expanded ? 'true' : 'false'); });
    }
    function focusables(el) { return qsa(FOCUSABLE, el).filter(function (n) { return n.offsetParent !== null || n === document.activeElement; }); }

    function open(el, trigger) {
      if (typeof el === 'string') el = document.getElementById(el);
      if (!el) return;
      if (current === el) return;
      if (current) close(true);
      clearTimeout(closeTimer);
      current = el;
      lastTrigger = trigger || document.activeElement;
      el.hidden = false;
      if (el.closest('[data-sf-header]')) document.body.classList.add('sf-header-front');
      if (overlay && !el.hasAttribute('data-sf-lightbox')) { overlay.hidden = false; }
      void el.offsetWidth;
      el.classList.add('is-open');
      if (overlay && !el.hasAttribute('data-sf-lightbox')) overlay.classList.add('is-visible');
      document.body.classList.add('sf-lock');
      setTriggers(el.id, true);
      var auto = qs('[data-sf-autofocus], input[type="search"]', el) || focusables(el)[0];
      setTimeout(function () { if (auto) auto.focus({ preventScroll: true }); }, 60);
      el.dispatchEvent(new CustomEvent('sf:open', { bubbles: true }));
    }

    function close(instant) {
      if (!current) return;
      var el = current;
      current = null;
      el.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      setTriggers(el.id, false);
      document.body.classList.remove('sf-lock');
      var done = function () {
        if (current === el) return;
        el.hidden = true;
        if (!current) { document.body.classList.remove('sf-header-front'); if (overlay) overlay.hidden = true; }
      };
      if (instant) done(); else closeTimer = setTimeout(done, 450);
      el.dispatchEvent(new CustomEvent('sf:close', { bubbles: true }));
      if (!instant && lastTrigger && document.contains(lastTrigger)) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} }
    }

    document.addEventListener('keydown', function (e) {
      if (!current) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var f = focusables(current);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (!current.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      }
    });
    if (overlay) overlay.addEventListener('click', function () { close(); });

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-sf-open]');
      if (openBtn) { e.preventDefault(); open(openBtn.getAttribute('data-sf-open'), openBtn); return; }
      var closeBtn = e.target.closest('[data-sf-close]');
      if (closeBtn && current && current.contains(closeBtn)) { e.preventDefault(); close(); }
    });

    return { open: open, close: close, current: function () { return current; } };
  })();

  /* ------------------------------------------------------------- header */
  function initHeader() {
    var header = qs('[data-sf-header]');
    if (!header) return;
    var bar = qs('.sf-header__bar', header);
    var sticky = header.classList.contains('sf-header--sticky');
    var setOffset = function () {
      document.documentElement.style.setProperty('--sf-header-sticky-offset', sticky ? bar.offsetHeight + 'px' : '0px');
    };
    setOffset();
    window.addEventListener('resize', debounce(setOffset, 150));
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Desktop dropdowns: hover with intent delay, click/keyboard toggle, Escape closes.
    qsa('.sf-nav__item--parent', header).forEach(function (item) {
      var link = qs('.sf-nav__link', item);
      var t;
      var set = function (on) {
        item.classList.toggle('is-open', on);
        link.setAttribute('aria-expanded', on ? 'true' : 'false');
      };
      item.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { set(true); }, 80); });
      item.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { set(false); }, 160); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) set(false); });
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape' && item.classList.contains('is-open')) { set(false); link.focus(); } });
      if (link.tagName === 'BUTTON') link.addEventListener('click', function () { set(!item.classList.contains('is-open')); });
    });

    // Mobile menu panels
    header.addEventListener('click', function (e) {
      var go = e.target.closest('[data-sf-menu-go]');
      if (!go) return;
      var id = go.getAttribute('data-sf-menu-go');
      var menu = go.closest('.sf-menu');
      qsa('[data-sf-menu-panel]', menu).forEach(function (p) {
        var on = p.getAttribute('data-sf-menu-panel') === id;
        p.hidden = !on;
        p.classList.toggle('is-active', on);
      });
      var target = qs('[data-sf-menu-panel="' + id + '"]', menu);
      var f = target && qs('button, a', target);
      if (f) f.focus();
    });
    document.addEventListener('sf:close', function (e) {
      if (e.target.id !== 'SfMenuDrawer') return;
      qsa('[data-sf-menu-panel]', e.target).forEach(function (p) {
        var root = p.getAttribute('data-sf-menu-panel') === 'root';
        p.hidden = !root; p.classList.toggle('is-active', root);
      });
    });
  }

  /* ------------------------------------------------------------- search */
  function initSearch() {
    var panel = qs('[data-sf-search]');
    if (!panel) return;
    var input = qs('[data-sf-search-input]', panel);
    var terms = qs('[data-sf-search-terms]', panel);
    var grid = qs('[data-sf-search-results]', panel);
    var more = qs('[data-sf-search-more]', panel);
    var asideLabel = qs('[data-sf-search-aside-label]', panel);
    var resultsLabel = qs('[data-sf-search-results-label]', panel);
    var defaults = { terms: terms.innerHTML, grid: grid.innerHTML, aside: asideLabel.textContent, results: resultsLabel.textContent };
    var ctrl;

    var reset = function () {
      terms.innerHTML = defaults.terms; grid.innerHTML = defaults.grid;
      asideLabel.textContent = defaults.aside; resultsLabel.textContent = defaults.results;
      resultsLabel.hidden = !defaults.results.trim() || !defaults.grid.trim();
      more.hidden = true; more.innerHTML = '';
    };
    resultsLabel.hidden = !defaults.results.trim() || !defaults.grid.trim();

    var run = debounce(function () {
      var q = input.value.trim();
      if (ctrl) ctrl.abort();
      if (!q) { reset(); return; }
      ctrl = new AbortController();
      grid.classList.add('is-loading');
      var url = (R.predictiveSearch || '/search/suggest') + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query,collection&resources[limit]=6&resources[options][unavailable_products]=last&section_id=sf-predictive-search';
      fetch(url, { signal: ctrl.signal })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var t = qs('[data-sf-ps-terms]', doc), p = qs('[data-sf-ps-products]', doc), m = qs('[data-sf-ps-more]', doc);
          terms.innerHTML = t ? t.innerHTML : '';
          asideLabel.textContent = 'Suggestions';
          asideLabel.hidden = !(t && t.innerHTML.trim());
          grid.innerHTML = p ? p.innerHTML : '';
          resultsLabel.textContent = 'Products';
          resultsLabel.hidden = false;
          more.innerHTML = m ? m.innerHTML : '';
          more.hidden = !(m && m.innerHTML.trim());
        })
        .catch(function (err) { if (err.name !== 'AbortError') grid.innerHTML = '<p class="sf-search__none">' + S.error + '</p>'; })
        .then(function () { grid.classList.remove('is-loading'); });
    }, 250);

    input.addEventListener('input', run);
    panel.addEventListener('sf:close', function () { asideLabel.hidden = false; });
  }

  /* -------------------------------------------------------- announcement */
  // CSS-driven marquee; pauses for reduced motion via CSS.

  /* --------------------------------------------------------------- hero */
  function initHero(root) {
    qsa('[data-sf-slider]', root).forEach(function (hero) {
      if (hero.__sf) return; hero.__sf = true;
      var slides = qsa('[data-sf-slide]', hero);
      var dots = qsa('[data-sf-dot]', hero);
      var idx = 0, timer;
      var delay = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var go = function (n) {
        if (slides.length < 2) return;
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          var on = i === idx;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          qsa('a', s).forEach(function (a) { a.tabIndex = on ? 0 : -1; });
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
      };
      var play = function () { stop(); if (delay > 0 && !reduce && slides.length > 1) timer = setInterval(function () { go(idx + 1); }, delay * 1000); };
      var stop = function () { clearInterval(timer); };
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-sf-dot'), 10)); play(); }); });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', play);
      var sx = null;
      hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) { go(idx + (dx < 0 ? 1 : -1)); play(); }
      });
      var next = qs('[data-sf-scroll-next]', hero);
      if (next) next.addEventListener('click', function () {
        var sec = hero.closest('.shopify-section');
        var after = sec && sec.nextElementSibling;
        var top = after ? after.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sf-header-sticky-offset'), 10) || 0) : window.innerHeight;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
      play();
    });
  }

  /* -------------------------------------------------------------- rails */
  function initRails(root) {
    qsa('[data-sf-rail]', root).forEach(function (rail) {
      if (rail.__sf) return; rail.__sf = true;
      var track = qs('[data-sf-rail-track]', rail);
      var prev = qs('[data-sf-rail-prev]', rail), next = qs('[data-sf-rail-next]', rail);
      if (!track) return;
      var update = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      };
      var step = function (dir) {
        var item = track.firstElementChild;
        var w = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth * 0.8;
        var per = Math.max(1, Math.floor(track.clientWidth / w));
        track.scrollBy({ left: dir * per * w, behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', debounce(update, 60), { passive: true });
      window.addEventListener('resize', debounce(update, 150));
      update();

      // Shopify-sorted rails (best selling / newest): replace with the sorted collection render.
      var src = track.getAttribute('data-sf-sorted-src');
      if (src) {
        var limit = parseInt(track.getAttribute('data-sf-limit'), 10) || 12;
        track.classList.add('is-loading');
        fetch(src).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
          var doc = parseHTML(html);
          var items = qsa('.sf-rail__item', doc).slice(0, limit);
          if (items.length) {
            track.innerHTML = '';
            items.forEach(function (it) { track.appendChild(document.importNode(it, true)); });
            initCards(track);
            Wishlist.sync(track);
          }
        }).catch(function () {}).then(function () { track.classList.remove('is-loading'); update(); });
      }
    });
  }

  /* --------------------------------------------------------------- cart */
  var Cart = (function () {
    var drawer = qs('[data-sf-cart-drawer]');

    function setCount(n) {
      qsa('[data-sf-cart-count]').forEach(function (c) { c.textContent = n; c.hidden = n < 1; });
    }

    function renderDrawer(html) {
      if (!drawer || !html) return;
      var doc = parseHTML(html);
      var fresh = qs('[data-sf-cart-drawer]', doc);
      if (!fresh) return;
      var recs = qs('[data-sf-cart-recs]', drawer);
      var keepRecs = recs ? recs.innerHTML : '';
      drawer.innerHTML = fresh.innerHTML;
      var newRecs = qs('[data-sf-cart-recs]', drawer);
      if (newRecs && keepRecs) { newRecs.innerHTML = keepRecs; newRecs.hidden = false; }
    }

    function loadRecs() {
      if (!drawer) return;
      var holder = qs('[data-sf-cart-recs]', drawer);
      var first = qs('[data-sf-line]', drawer);
      if (!holder) return;
      if (!first) { holder.hidden = true; holder.innerHTML = ''; return; }
      var pid = first.getAttribute('data-product-id');
      if (!pid || holder.getAttribute('data-for') === pid) return;
      var base = '/recommendations/products?product_id=' + pid + '&limit=4&section_id=sf-cart-recs&intent=';
      var get = function (intent) { return fetch(base + intent).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) { var d = parseHTML(h); var s = qs('.shopify-section', d) || d.body; return s.innerHTML.trim(); }); };
      get('complementary').then(function (h) { return h || get('related'); }).then(function (h) {
        holder.innerHTML = h || '';
        holder.hidden = !h;
        holder.setAttribute('data-for', pid);
      }).catch(function () {});
    }

    function refreshCartPage() {
      var page = qs('[data-sf-cart-page]');
      if (!page) return Promise.resolve();
      return fetch(R.cart || '/cart').then(function (r) { return r.text(); }).then(function (html) {
        var fresh = qs('[data-sf-cart-page]', parseHTML(html));
        if (fresh) page.innerHTML = fresh.innerHTML;
      });
    }

    function afterChange(data) {
      if (data && data.sections) renderDrawer(data.sections['sf-cart-drawer']);
      var count = data && typeof data.item_count === 'number' ? data.item_count : null;
      if (count === null) {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      }
      setCount(count);
      return Promise.resolve();
    }

    function add(items, opener) {
      var body = { items: items, sections: ['sf-cart-drawer'], sections_url: window.location.pathname };
      return fetch((R.cartAdd || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok || j.status) { var err = new Error(j.description || j.message || S.error); err.data = j; throw err; } return j; });
      }).then(function (j) {
        renderDrawer(j.sections && j.sections['sf-cart-drawer']);
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          setCount(c.item_count);
          document.dispatchEvent(new CustomEvent('sf:cart:added', { detail: { cart: c } }));
          if (T.cartDrawer && drawer && !qs('[data-sf-cart-page]')) { loadRecs(); Drawer.open(drawer, opener); }
          else if (qs('[data-sf-cart-page]')) { refreshCartPage(); toast(S.added); }
          else { toast(S.added); }
        });
      });
    }

    function change(line, qty) {
      var host = drawer && drawer.contains(line) ? drawer : qs('[data-sf-cart-page]');
      if (host) host.classList.add('is-busy');
      var key = line.getAttribute('data-sf-line');
      return fetch((R.cartChange || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: ['sf-cart-drawer'], sections_url: window.location.pathname })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || S.error); return j; });
      }).then(function (j) {
        return afterChange(j).then(refreshCartPage).then(loadRecs);
      }).catch(function (err) { toast(err.message || S.error); return refreshCartPage(); })
        .then(function () { if (host) host.classList.remove('is-busy'); });
    }

    var saveNote = debounce(function (val) {
      fetch((R.cartUpdate || '/cart/update') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: val }) });
    }, 500);

    document.addEventListener('click', function (e) {
      var tog = e.target.closest('[data-sf-cart-toggle]');
      if (tog && T.cartDrawer && drawer && !qs('[data-sf-cart-page]')) {
        e.preventDefault();
        if (Drawer.current() === drawer) { Drawer.close(); return; }
        loadRecs();
        Drawer.open(drawer, tog);
        return;
      }
      var qbtn = e.target.closest('[data-sf-qty-change]');
      if (qbtn) {
        var line = qbtn.closest('[data-sf-line]');
        var input = qs('[data-sf-qty-input]', line);
        var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(qbtn.getAttribute('data-sf-qty-change'), 10));
        input.value = q;
        change(line, q);
        return;
      }
      var rm = e.target.closest('[data-sf-remove]');
      if (rm) { change(rm.closest('[data-sf-line]'), 0); }
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-sf-qty-input]')) {
        var q = Math.max(0, parseInt(e.target.value, 10) || 0);
        change(e.target.closest('[data-sf-line]'), q);
      }
    });
    document.addEventListener('input', function (e) { if (e.target.matches('[data-sf-cart-note]')) saveNote(e.target.value); });

    return { add: add, setCount: setCount, loadRecs: loadRecs };
  })();

  /* -------------------------------------------------------- product card */
  function cardData(card) {
    if (card.__data !== undefined) return card.__data;
    var j = qs('[data-sf-card-json]', card);
    try { card.__data = j ? JSON.parse(j.textContent) : null; } catch (e) { card.__data = null; }
    return card.__data;
  }
  function cardColor(card) {
    var a = qs('[data-sf-swatch].is-active', card);
    return a ? a.getAttribute('data-sf-swatch') : null;
  }
  function cardIdx(card, attr) {
    var v = card.getAttribute(attr);
    return v === null ? null : parseInt(v, 10);
  }
  function refreshQuick(card) {
    var data = cardData(card);
    if (!data) return;
    var si = cardIdx(card, 'data-size-index'), ci = cardIdx(card, 'data-color-index');
    var color = cardColor(card);
    qsa('[data-sf-quick-size]', card).forEach(function (b) {
      var size = b.getAttribute('data-sf-quick-size');
      var v = data.variants.filter(function (x) { return x.o[si] === size && (ci === null || color === null || x.o[ci] === color); })[0];
      var ok = !!(v && v.a);
      b.classList.toggle('is-unavailable', !ok);
      b.disabled = !ok;
      b.setAttribute('aria-label', 'Add size ' + size + (color ? ' in ' + color : '') + ' to cart' + (ok ? '' : ' (sold out)'));
    });
    var cb = qs('[data-sf-quick-color]', card);
    if (cb && ci !== null) {
      var v2 = data.variants.filter(function (x) { return x.o[ci] === color; })[0];
      cb.disabled = !(v2 && v2.a);
      cb.textContent = cb.disabled ? S.soldOut : S.addToCart;
    }
  }
  function initCards(root) { qsa('[data-sf-card]', root).forEach(refreshQuick); }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-sf-swatch]');
    if (sw) {
      var card = sw.closest('[data-sf-card]');
      qsa('[data-sf-swatch]', card).forEach(function (s) { s.classList.toggle('is-active', s === sw); s.setAttribute('aria-checked', s === sw ? 'true' : 'false'); });
      var img = qs('[data-sf-card-img]', card), src = sw.getAttribute('data-img');
      if (img && src) { img.removeAttribute('srcset'); img.src = src; }
      var link = card.getAttribute('data-product-url');
      var data = cardData(card), ci = cardIdx(card, 'data-color-index');
      if (data && ci !== null) {
        var v = data.variants.filter(function (x) { return x.o[ci] === sw.getAttribute('data-sf-swatch'); })[0];
        if (v) qsa('a[href^="' + link.split('?')[0] + '"]', card).forEach(function (a) { a.href = link.split('?')[0] + '?variant=' + v.id; });
      }
      refreshQuick(card);
      return;
    }

    var qs_ = e.target.closest('[data-sf-quick-size], [data-sf-quick-color], [data-sf-quick-add]');
    if (!qs_) return;
    e.preventDefault();
    var c = qs_.closest('[data-sf-card]');
    var id = null;
    if (qs_.hasAttribute('data-sf-quick-add')) {
      id = parseInt(qs_.getAttribute('data-sf-quick-add'), 10);
    } else {
      var d = cardData(c);
      var si = cardIdx(c, 'data-size-index'), ci2 = cardIdx(c, 'data-color-index');
      var color = cardColor(c);
      // Never guess: with a colour option and no visible colour choice, send shoppers to the product page.
      if (ci2 !== null && color === null) { window.location.href = c.getAttribute('data-product-url'); return; }
      var match = d && d.variants.filter(function (x) {
        if (qs_.hasAttribute('data-sf-quick-size') && x.o[si] !== qs_.getAttribute('data-sf-quick-size')) return false;
        if (ci2 !== null && x.o[ci2] !== color) return false;
        return true;
      });
      if (!match || match.length !== 1 || !match[0].a) { toast(S.unavailable); return; }
      id = match[0].id;
    }
    if (!id) return;
    qs_.classList.add('is-busy');
    Cart.add([{ id: id, quantity: 1 }], qs_).catch(function (err) { toast(err.message || S.error); })
      .then(function () { qs_.classList.remove('is-busy'); });
  });

  /* ----------------------------------------------------------- wishlist */
  var Wishlist = (function () {
    var KEY = 'sn_wishlist';
    function list() { try { var l = JSON.parse(store(KEY) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
    function save(l) { store(KEY, JSON.stringify(l)); }
    function has(pid) { return list().some(function (x) { return String(x).split('|')[0] === pid; }); }
    function sync(root) {
      var l = list();
      var ids = l.map(function (x) { return String(x).split('|')[0]; });
      qsa('[data-sf-wish]', root).forEach(function (b) {
        var on = ids.indexOf(b.getAttribute('data-sf-wish').split('|')[0]) > -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var base = (b.getAttribute('aria-label') || '').replace(/^(Add|Remove) /, '').replace(/ (to|from) wishlist$/, '');
        if (base && base !== 'wishlist') b.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + base + (on ? ' from wishlist' : ' to wishlist'));
      });
      qsa('[data-sf-wish-count]').forEach(function (c) { c.textContent = l.length; c.hidden = l.length < 1; });
    }
    function toggle(entry) {
      var pid = entry.split('|')[0];
      var l = list();
      var on = has(pid);
      if (on) l = l.filter(function (x) { return String(x).split('|')[0] !== pid; });
      else l.unshift(entry);
      save(l);
      sync();
      toast(on ? 'Removed from wishlist' : 'Saved to wishlist');
      return !on;
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sf-wish]');
      if (!b) return;
      e.preventDefault();
      var added = toggle(b.getAttribute('data-sf-wish'));
      b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
      if (!added) {
        var page = qs('[data-sf-wishlist-page]');
        var li = page && b.closest('.sf-grid__item');
        if (li && page.contains(li)) { li.remove(); renderCount(); }
      }
    });
    window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

    function renderCount() {
      var page = qs('[data-sf-wishlist-page]');
      if (!page) return;
      var n = qsa('[data-sf-wishlist-grid] .sf-grid__item', page).length;
      qs('[data-sf-wishlist-count]', page).textContent = n + (n === 1 ? ' item' : ' items');
      qs('[data-sf-wishlist-empty]', page).hidden = n > 0;
      qs('[data-sf-wishlist-grid]', page).hidden = n === 0;
    }
    function renderPage() {
      var page = qs('[data-sf-wishlist-page]');
      if (!page) return;
      var grid = qs('[data-sf-wishlist-grid]', page);
      var entries = list().filter(function (x) { return String(x).split('|')[1]; });
      if (!entries.length) { grid.innerHTML = ''; grid.removeAttribute('aria-busy'); renderCount(); return; }
      Promise.all(entries.map(function (x) {
        var handle = String(x).split('|')[1];
        return fetch('/products/' + encodeURIComponent(handle) + '?section_id=sf-card-render')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h) { var card = h && qs('[data-sf-card]', parseHTML(h)); return card ? card.outerHTML : ''; })
          .catch(function () { return ''; });
      })).then(function (cards) {
        grid.innerHTML = cards.filter(Boolean).map(function (c) { return '<li class="sf-grid__item">' + c + '</li>'; }).join('');
        grid.removeAttribute('aria-busy');
        initCards(grid); sync(grid); renderCount();
      });
    }
    return { sync: sync, renderPage: renderPage };
  })();

  /* ------------------------------------------------------- product page */
  function initProduct(section) {
    if (section.__sf) return; section.__sf = true;
    var jsonEl = qs('[data-sf-product-json]', section);
    if (!jsonEl) return;
    var P = JSON.parse(jsonEl.textContent);
    var form = qs('[data-sf-product-form]', section);
    var idInput = qs('[data-sf-variant-id]', section);
    var priceEl = qs('[data-sf-price]', section);
    var atc = qs('[data-sf-atc]', section);
    var atcLabel = qs('[data-sf-atc-label]', section);
    var err = qs('[data-sf-form-error]', section);
    var sticky = qs('[data-sf-sticky-atc]', section);
    var stickyBtn = qs('[data-sf-sticky-btn]', section);
    var stickyPrice = qs('[data-sf-sticky-price]', section);
    var slides = qsa('[data-sf-pdp-slide]', section);
    var thumbs = qsa('[data-sf-thumb]', section);
    var slidesWrap = qs('[data-sf-pdp-slides]', section);
    var counter = qs('[data-sf-pdp-current]', section);
    var mobile = window.matchMedia('(max-width: 749px)');
    var current = 0;

    function show(i, fromScroll) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { var on = n === current; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === current);
        if (n === current) {
          t.setAttribute('aria-current', 'true');
          var list = t.parentElement;
          var top = t.offsetTop - list.offsetTop;
          if (top < list.scrollTop || top + t.clientHeight > list.scrollTop + list.clientHeight) list.scrollTo({ top: top - list.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
        }
        else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = current + 1;
      if (mobile.matches && !fromScroll && slidesWrap) slidesWrap.scrollTo({ left: slidesWrap.clientWidth * current, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-sf-thumb'), 10)); }); });
    var pv = qs('[data-sf-pdp-prev]', section), nx = qs('[data-sf-pdp-next]', section);
    if (pv) pv.addEventListener('click', function () { show(current - 1); });
    if (nx) nx.addEventListener('click', function () { show(current + 1); });
    var more = qs('[data-sf-thumbs-more]', section);
    if (more) more.addEventListener('click', function () { var l = qs('[data-sf-thumbs-list]', section); l.scrollBy({ top: l.clientHeight * 0.8, behavior: 'smooth' }); });
    if (slidesWrap) slidesWrap.addEventListener('scroll', debounce(function () {
      if (!mobile.matches) return;
      var i = Math.round(slidesWrap.scrollLeft / slidesWrap.clientWidth);
      if (i !== current) show(i, true);
    }, 80), { passive: true });
    var active = slides.filter(function (s) { return s.classList.contains('is-active'); })[0];
    if (active) current = slides.indexOf(active);
    if (mobile.matches && current > 0 && slidesWrap) slidesWrap.scrollLeft = slidesWrap.clientWidth * current;

    // Lightbox zoom
    var lb = qs('[data-sf-lightbox]', section);
    var lbImg = lb && qs('[data-sf-lb-img]', lb);
    var lbIdx = 0;
    var imgMedia = P.media;
    function lbShow(i) {
      if (!imgMedia.length) return;
      lbIdx = (i + imgMedia.length) % imgMedia.length;
      lbImg.src = imgMedia[lbIdx].src;
      lbImg.alt = '';
      lbImg.parentElement.classList.remove('is-zoomed');
    }
    qsa('[data-sf-zoom]', section).forEach(function (z) {
      z.addEventListener('click', function () {
        if (!lb) return;
        if (mobile.matches && slidesWrap && slidesWrap.__dragging) return;
        lbShow(parseInt(z.getAttribute('data-sf-zoom'), 10));
        Drawer.open(lb, z);
      });
    });
    if (lb) {
      qs('[data-sf-lb-prev]', lb).addEventListener('click', function () { lbShow(lbIdx - 1); });
      qs('[data-sf-lb-next]', lb).addEventListener('click', function () { lbShow(lbIdx + 1); });
      lbImg.addEventListener('click', function (e) {
        var fig = lbImg.parentElement;
        var on = fig.classList.toggle('is-zoomed');
        if (on) {
          var r = lbImg.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
          requestAnimationFrame(function () { fig.scrollLeft = fig.scrollWidth * px - fig.clientWidth / 2; fig.scrollTop = fig.scrollHeight * py - fig.clientHeight / 2; });
        }
      });
      lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') lbShow(lbIdx - 1); if (e.key === 'ArrowRight') lbShow(lbIdx + 1); });
    }

    // Variant picker
    var optionEls = qsa('[data-sf-option]', section);
    function selected() {
      return optionEls.map(function (el) {
        var r = qs('input[type="radio"]:checked', el);
        if (r) return r.value;
        var s = qs('select', el);
        return s ? s.value : null;
      });
    }
    function find(opts) {
      return P.variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === null || o === opts[i]; }); })[0];
    }
    function priceHTML(v) {
      if (v.compare_at_price > v.price) return '<span class="sf-price--sale">' + formatMoney(v.price) + '</span> <s class="sf-price--compare">' + formatMoney(v.compare_at_price) + '</s>';
      return '<span>' + formatMoney(v.price) + '</span>';
    }
    function markAvailability(opts) {
      optionEls.forEach(function (el, i) {
        var mark = function (value) {
          var test = opts.slice(); test[i] = value;
          var v = P.variants.filter(function (x) { return x.options.every(function (o, n) { return o === test[n]; }); })[0];
          return { exists: !!v, available: !!(v && v.available) };
        };
        qsa('input[type="radio"]', el).forEach(function (r) {
          var st = mark(r.value);
          r.closest('.sf-swatch').classList.toggle('is-unavailable', !st.available);
        });
        qsa('option', el).forEach(function (o) {
          var st = mark(o.value);
          o.textContent = o.value + (st.exists ? (st.available ? '' : ' — ' + S.soldOut) : ' — ' + S.unavailable);
        });
      });
    }
    function update(push) {
      var opts = selected();
      var v = find(opts);
      optionEls.forEach(function (el, i) { var lab = qs('[data-sf-option-value]', el); if (lab) lab.textContent = opts[i]; });
      markAvailability(opts);
      if (err) err.hidden = true;
      if (!v) {
        atc.disabled = true; atcLabel.textContent = S.unavailable;
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = S.unavailable; }
        return;
      }
      idInput.value = v.id;
      priceEl.innerHTML = priceHTML(v);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? S.addToCart : S.soldOut;
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? S.addToCart : S.soldOut; }
      if (v.media_id) {
        var target = slides.filter(function (s) { return s.getAttribute('data-media-id') === String(v.media_id); })[0];
        if (target) show(slides.indexOf(target));
      }
      if (push) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      section.dispatchEvent(new CustomEvent('sf:variant', { bubbles: true, detail: { variant: v } }));
    }
    optionEls.forEach(function (el) { el.addEventListener('change', function () { update(true); }); });
    update(false);

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      atc.setAttribute('aria-busy', 'true'); atc.disabled = true;
      var fd = new FormData(form);
      var props = {};
      fd.forEach(function (val, key) { var m = key.match(/^properties\[(.+)\]$/); if (m && val) props[m[1]] = val; });
      var item = { id: parseInt(idInput.value, 10), quantity: parseInt(fd.get('quantity'), 10) || 1 };
      if (Object.keys(props).length) item.properties = props;
      var selling = fd.get('selling_plan'); if (selling) item.selling_plan = selling;
      Cart.add([item], atc).catch(function (ex) {
        if (err) { err.textContent = ex.message || S.error; err.hidden = false; }
      }).then(function () { atc.removeAttribute('aria-busy'); update(false); });
    });

    if (sticky && atc && 'IntersectionObserver' in window) {
      var buy = qs('[data-sf-buy]', section);
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show_ = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show_);
        sticky.setAttribute('aria-hidden', show_ ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show_ ? 0 : -1;
      });
      io.observe(buy || atc);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (!stickyBtn.disabled) { if (form.requestSubmit) form.requestSubmit(); else atc.click(); }
      });
    }
  }

  /* ---------------------------------------------- product recommendations */
  function initRecs(root) {
    qsa('[data-sf-recs][data-url]', root).forEach(function (el) {
      if (el.__sf) return; el.__sf = true;
      fetch(el.getAttribute('data-url')).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var doc = parseHTML(html);
        if (el.classList.contains('sf-gtl')) {
          var wrap = qs('.shopify-section', doc) || doc.body;
          var inner = wrap.innerHTML.trim();
          if (inner) { el.innerHTML = inner; el.hidden = false; }
          return;
        }
        var fresh = qs('[data-sf-recs]', doc);
        if (fresh && qs('[data-sf-card]', fresh)) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
          el.__sf = true;
          qsa('[data-sf-rail]', el).forEach(function (r) { r.__sf = false; });
          initRails(el); initCards(el); Wishlist.sync(el);
        }
      }).catch(function () {});
    });
  }

  /* --------------------------------------------- collection filters & sort */
  function initCollection() {
    var sec = qs('[data-sf-collection][data-section-id]');
    if (!sec) return;
    var sid = sec.getAttribute('data-section-id');

    function load(url, push) {
      var body = qs('[data-sf-collection-body]', sec);
      if (Drawer.current() && Drawer.current().hasAttribute('data-sf-filters')) Drawer.close(true);
      if (body) { body.classList.add('is-loading'); body.setAttribute('aria-busy', 'true'); }
      var u = new URL(url, window.location.origin);
      u.searchParams.delete('page');
      u.searchParams.set('section_id', sid);
      return fetch(u.toString()).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
        var doc = parseHTML(html);
        var nb = qs('[data-sf-collection-body]', doc);
        var nf = qs('[data-sf-filters]', doc);
        var of = qs('[data-sf-filters]', sec);
        if (nb && body) body.outerHTML = nb.outerHTML;
        if (of && nf) of.outerHTML = nf.outerHTML;
        else if (!of && nf) sec.appendChild(nf);
        else if (of && !nf) of.remove();
        u.searchParams.delete('section_id');
        if (push !== false) history.pushState({ sf: true }, '', u.pathname + (u.search || ''));
        var nbody = qs('[data-sf-collection-body]', sec);
        initCards(nbody); Wishlist.sync(nbody);
        var top = nbody.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sf-header-sticky-offset'), 10) || 0) - 8;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
        var count = qs('[data-sf-count]', nbody);
        if (count) toast(count.textContent.trim());
      }).catch(function () { window.location.href = url; });
    }

    sec.addEventListener('change', function (e) {
      if (!e.target.matches('[data-sf-sort]')) return;
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', e.target.value);
      load(u.toString());
    });
    sec.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-sf-filter-form]');
      if (!f) return;
      e.preventDefault();
      var params = new URLSearchParams();
      new FormData(f).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var cur = new URL(window.location.href);
      if (!params.get('sort_by') && cur.searchParams.get('sort_by')) params.set('sort_by', cur.searchParams.get('sort_by'));
      load(f.getAttribute('action') + '?' + params.toString());
    });
    sec.addEventListener('click', function (e) {
      var a = e.target.closest('[data-sf-filter-link]');
      if (!a) return;
      e.preventDefault();
      load(a.href);
    });
    window.addEventListener('popstate', function (e) { if (e.state && e.state.sf) load(window.location.href, false); else if (qs('[data-sf-collection-body]')) load(window.location.href, false); });
  }

  /* ----------------------------------------------------- newsletter popup */
  function initPopup() {
    var pop = qs('[data-sf-popup]');
    if (!pop) return;
    var KEY = 'sf_news_popup';
    var days = parseInt(pop.getAttribute('data-days'), 10) || 14;
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 6) * 1000;
    if (qs('[data-sf-popup-success]', pop) || /SfPopupNewsletter/.test(window.location.hash) && qs('.sf-news-form__msg', pop)) {
      Drawer.open(pop); store(KEY, String(Date.now() + 3650 * 864e5)); return;
    }
    var until = parseInt(store(KEY), 10) || 0;
    if (Date.now() < until) return;
    if (document.body.classList.contains('template-cart') || window.Shopify && window.Shopify.designMode) return;
    pop.addEventListener('sf:close', function () { store(KEY, String(Date.now() + days * 864e5)); });
    setTimeout(function () { if (!Drawer.current()) Drawer.open(pop); }, delay);
  }

  /* ------------------------------------------------------------- boot */
  function initAll(root) {
    initHero(root); initRails(root); initCards(root); initRecs(root); Wishlist.sync(root);
    qsa('[data-sf-product]', root).forEach(initProduct);
  }

  initHeader();
  initSearch();
  initAll(document);
  initCollection();
  Wishlist.renderPage();
  initPopup();
  if (qs('[data-sf-cart-drawer] [data-sf-line]')) Cart.loadRecs();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-sf-slide]');
    if (slide) { var hero = slide.closest('[data-sf-slider]'); var dots = qsa('[data-sf-dot]', hero); var i = qsa('[data-sf-slide]', hero).indexOf(slide); if (dots[i]) dots[i].click(); }
  });

  window.SfTheme = { Drawer: Drawer, Cart: Cart, Wishlist: Wishlist, formatMoney: formatMoney, toast: toast };
})();
